import Text from "ab-text";
import Link from "ab-link";
import ContactForm from "ab-form-contact";
import { useTranslation } from "next-i18next";
import "./ab-contact.scss";

const Contact = ({ i18n }) => {
  const { t } = useTranslation("common", { i18n });

  return (
    <div className="ab-contact">
      <div className="left">
        <Text element="span" className="title">
          {t("questions")}
        </Text>
        <Text element="h3">{t("envienos")}</Text>

        <a href="mailto:info@abadia-retuerta.es">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.8514 8.9765C7.4054 8.9765 6.96073 8.82916 6.58873 8.5345L3.59873 6.12383C3.3834 5.9505 3.35007 5.63516 3.52273 5.4205C3.69673 5.2065 4.0114 5.1725 4.22607 5.34516L7.2134 7.75316C7.58873 8.0505 8.1174 8.0505 8.4954 7.7505L11.4527 5.3465C11.6674 5.17116 11.9821 5.2045 12.1567 5.41916C12.3307 5.63316 12.2981 5.94783 12.0841 6.1225L9.1214 8.5305C8.74673 8.82783 8.29873 8.9765 7.8514 8.9765Z"
              fill="#A79669"
            />
            <mask
              id="mask0"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="0"
              y="1"
              width="15"
              height="14"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.666748 1.33331H15V14.3333H0.666748V1.33331Z"
                fill="white"
              />
            </mask>
            <g mask="url(#mask0)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.55941 13.3333H11.1061C11.1074 13.332 11.1127 13.3333 11.1167 13.3333C11.8774 13.3333 12.5521 13.0613 13.0694 12.5446C13.6701 11.9466 14.0001 11.0873 14.0001 10.1253V5.54665C14.0001 3.68465 12.7827 2.33331 11.1061 2.33331H4.56075C2.88408 2.33331 1.66675 3.68465 1.66675 5.54665V10.1253C1.66675 11.0873 1.99741 11.9466 2.59741 12.5446C3.11475 13.0613 3.79008 13.3333 4.55008 13.3333H4.55941ZM4.54808 14.3333C3.51941 14.3333 2.60075 13.96 1.89141 13.2533C1.10141 12.4653 0.666748 11.3546 0.666748 10.1253V5.54665C0.666748 3.14465 2.34075 1.33331 4.56075 1.33331H11.1061C13.3261 1.33331 15.0001 3.14465 15.0001 5.54665V10.1253C15.0001 11.3546 14.5654 12.4653 13.7754 13.2533C13.0667 13.9593 12.1474 14.3333 11.1167 14.3333H11.1061H4.56075H4.54808Z"
                fill="#A79669"
              />
            </g>
          </svg>
          info@abadia-retuerta.es
        </a>

        <div className="call">
          <span className="title">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="9"
                y="1"
                width="7"
                height="7"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.56934 1.3335H15.262V7.02204H9.56934V1.3335Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.7618 7.02204C14.5105 7.02204 14.2945 6.83337 14.2658 6.57804C14.0131 4.32737 12.2651 2.58071 10.0138 2.33071C9.7398 2.30004 9.5418 2.05337 9.57247 1.77871C9.60247 1.50471 9.84713 1.30271 10.1245 1.33737C12.8431 1.63937 14.9545 3.74804 15.2591 6.46604C15.2898 6.74071 15.0925 6.98804 14.8185 7.01871C14.7998 7.02071 14.7805 7.02204 14.7618 7.02204Z"
                  fill="#A79669"
                />
              </g>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.4017 7.02924C12.167 7.02924 11.9584 6.86391 11.9117 6.62524C11.7197 5.63857 10.959 4.87791 9.97371 4.68657C9.70238 4.63391 9.52571 4.37191 9.57838 4.10057C9.63104 3.82924 9.89771 3.65191 10.1644 3.70524C11.5517 3.97457 12.623 5.04524 12.893 6.43324C12.9457 6.70524 12.769 6.96724 12.4984 7.01991C12.4657 7.02591 12.4337 7.02924 12.4017 7.02924Z"
                fill="#A79669"
              />
              <mask
                id="mask1"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="1"
                y="1"
                width="15"
                height="15"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.3335 1.33325H15.0003V15.0003H1.3335V1.33325Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask1)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.90622 3.37425C2.90755 3.37425 2.87422 3.40891 2.83222 3.45025C2.67089 3.60691 2.33689 3.93291 2.33355 4.61491C2.32822 5.56891 2.95555 7.34025 5.97622 10.3602C8.98222 13.3656 10.7509 14.0002 11.7076 14.0002H11.7216C12.4036 13.9962 12.7289 13.6622 12.8856 13.5016C12.9329 13.4529 12.9716 13.4162 12.9989 13.3942C13.6636 12.7256 14.0036 12.2289 14.0002 11.9096C13.9962 11.5842 13.5916 11.2002 13.0322 10.6676C12.8542 10.4989 12.6609 10.3142 12.4569 10.1102C11.9276 9.58291 11.6669 9.67291 11.0902 9.87558C10.2936 10.1549 9.20222 10.5376 7.50155 8.83558C5.80022 7.13491 6.18155 6.04358 6.45955 5.24625C6.66089 4.67025 6.75289 4.40825 6.22422 3.87891C6.01755 3.67225 5.83155 3.47625 5.66022 3.29625C5.13089 2.74025 4.74889 2.33825 4.42555 2.33358H4.42022C4.10089 2.33358 3.60489 2.67491 2.90289 3.37691C2.90489 3.37491 2.90555 3.37425 2.90622 3.37425ZM11.7076 15.0002C10.0462 15.0002 7.88022 13.6776 5.26955 11.0676C2.64822 8.44692 1.32355 6.27425 1.33355 4.60958C1.33955 3.50958 1.91622 2.94625 2.13289 2.73492C2.14422 2.72091 2.18289 2.68291 2.19622 2.66958C3.15289 1.71291 3.81022 1.31958 4.43822 1.33358C5.18289 1.34358 5.71355 1.90158 6.38489 2.60758C6.55089 2.78158 6.73022 2.97158 6.93088 3.17158C7.90355 4.14492 7.62689 4.93892 7.40355 5.57625C7.16089 6.27158 6.95089 6.87158 8.20822 8.12892C9.46555 9.38625 10.0649 9.17625 10.7596 8.93158C11.3976 8.70892 12.1896 8.43025 13.1642 9.40358C13.3622 9.60158 13.5489 9.77891 13.7222 9.94358C14.4309 10.6182 14.9909 11.1509 15.0002 11.8976C15.0076 12.5336 14.6209 13.1829 13.6662 14.1376L13.2436 13.8509L13.6016 14.1996C13.3902 14.4162 12.8282 14.9936 11.7276 15.0002H11.7076Z"
                  fill="#A79669"
                />
              </g>
            </svg>
            {t("llamenos")}
          </span>
          <span className="left">
            {t("reservas")}:<a href="tel:+34 983 687 600">+34 983 687 600</a>
          </span>
          <span className="left">
            {t("oficinas")}:<a href="tel:+34 983 680 368">+34 983 680 368</a>
          </span>
          <span className="left"></span>
        </div>

        <div className="map">
          <span className="title">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.16716 5.66669C7.52382 5.66669 7.00049 6.19002 7.00049 6.83402C7.00049 7.47735 7.52382 8.00002 8.16716 8.00002C8.81049 8.00002 9.33382 7.47735 9.33382 6.83402C9.33382 6.19002 8.81049 5.66669 8.16716 5.66669ZM8.16716 9.00002C6.97249 9.00002 6.00049 8.02869 6.00049 6.83402C6.00049 5.63869 6.97249 4.66669 8.16716 4.66669C9.36182 4.66669 10.3338 5.63869 10.3338 6.83402C10.3338 8.02869 9.36182 9.00002 8.16716 9.00002Z"
                fill="#A79669"
              />
              <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="2"
                y="1"
                width="12"
                height="14"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2.66675 1.33334H13.6664V14.3333H2.66675V1.33334Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0)">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.1665 2.33334C5.68517 2.33334 3.6665 4.37134 3.6665 6.87534C3.6665 10.0613 7.41584 13.1653 8.1665 13.3307C8.91717 13.1647 12.6665 10.0607 12.6665 6.87534C12.6665 4.37134 10.6478 2.33334 8.1665 2.33334ZM8.1665 14.3333C6.9705 14.3333 2.6665 10.632 2.6665 6.87534C2.6665 3.81934 5.13384 1.33334 8.1665 1.33334C11.1992 1.33334 13.6665 3.81934 13.6665 6.87534C13.6665 10.632 9.3625 14.3333 8.1665 14.3333Z"
                  fill="#A79669"
                />
              </g>
            </svg>
            {t("dondeLocalizarnos")}
          </span>
          <Text className="span left">Sardón de Duero </Text>
          <Text className="span left">47340 Valladolid (España)</Text>
        </div>

        <Link
          prefetch={false}
          text={t("mapa")}
          href={`https://goo.gl/maps/AQtzW4MJP5i8S4nH9`}
          target={"__blank"}
        />
      </div>

      <div className="right">
        <ContactForm i18n={i18n} />
      </div>
    </div>
  );
};

export default Contact;
